import React, { useEffect, useState } from 'react';
import './Home.css'
import fakeData from '../../FakeData/HomeProject';
import HomeBlog from '../../FakeData/HomeBlog';
import BlogsOfHome from '../HomeBlog/BlogsOfHome';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Home = () => {
  const firstFourProject = fakeData.slice(0, 3);
  const [fake, setFake] = useState(firstFourProject);
  const homeBlog3 = HomeBlog.slice(0, 3);
  const [homeBlog, setHomeBlog] = useState(homeBlog3);

  useEffect(() => {
    AOS.init({ duration: 1000 })

  })


  return (
    <div>
      <div>
        <div className="projects">

          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-12 col-12">
                <h4 id="name">Some Of My Projects</h4>
              </div>
              <div className="col-md-6 col-sm-7 col-7 space ">
                <hr className="one" />
              </div>

              <div className="col-md-3 col-sm-5 col-5">
                <Link to="/project">
                  <button className="button">All Projects</button>
                </Link>
              </div>

            </div>
            {
              fake.map(project => <FourProject project={project}></FourProject>)
            }
          </div>

        </div>
        <div className="blogs" id="blog">
          <div className="container">
            <div class="row">
              <div class="col-md-3 col-sm-12 col-12">
                <h4 class="content-heading">Some Of My Articles</h4>
              </div>
              <div class="col-md-6 col-sm-7 col-7 space ">
                <hr class="one" />
              </div>
              <div class="col-md-3 col-sm-5 col-5">
                <Link to="/blog">
                  <button class="button">All Articles</button>
                </Link>
              </div>
            </div>
            <div className='row'>
              {
                homeBlog.map(homeBlog => <BlogsOfHome homeBlog={homeBlog}></BlogsOfHome>)
              }
            </div>

          </div>

        </div>
      </div>

    </div>
  );
};

const FourProject = (props) => {


  const { id, projectName, technology, projectDescription, img1, img2, img3, cauroselId, cauroselId1, website, source, tech5, tech6 } = props.project;

  return (
    <div>

      <div data-aos="fade-right">
        <div className="block-project">
          <div className="row project">
            <div className="col-md-6">

              <div id={cauroselId1} className="carousel slide " data-ride="carousel">
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img src={img1} className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src={img2} className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src={img3} className="d-block w-100" alt="..." />
                  </div>
                </div>
                <a className="carousel-control-prev" href={cauroselId} role="button" data-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href={cauroselId} role="button" data-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="sr-only">Next</span>
                </a>
              </div>

            </div>
            <div className="col-md-6">
              <div className="project-description">
                <div className="card text-center project-body">
                  <div className="card-header">
                    {id}
                  </div>
                  <div className="card-body des">
                    <h2 className="card-title"> {projectName} </h2>
                    <p className="card-text">
                      {projectDescription}
                    </p>
                    <div className="build-item">
                      <strong className="built "> {technology.tech1} </strong>
                      <strong className="built "> {technology.tech2} </strong>
                      <strong className="built "> {technology.tech3} </strong>
                      <strong className="built "> {technology.tech4} </strong>
                      <strong className="built "> {technology.tech5} </strong>
                      <strong className="built "> {technology.tech6} </strong>
                    </div>
                  </div>
                  <div className="card-footer text-muted">
                    <div className="info-btn">
                      <a href={website} target="_blank" className="project-info-btn">Website</a>
                      <a href={source} target="_blank" className="project-info-btn">Source
                      Code</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;